import { Grid, Layout, theme } from 'antd'
import { Outlet } from 'react-router-dom'
import { AppHeader } from './AppHeader'
import { MobileTabBar } from './MobileTabBar'

export function AppLayout() {
  const { token } = theme.useToken()
  const screens = Grid.useBreakpoint()
  // `md` dan tor ekranda pastki tab-bar ishlatiladi — doimiy yon panel
  // telefon ekranining yarmini yeb qo'yardi
  const isMobile = screens.md === false

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <AppHeader isMobile={isMobile} />
      <Layout.Content
        className="xsib-content"
        style={{ padding: isMobile ? 12 : 24, background: token.colorBgLayout }}
      >
        {/* Kenglik chegarasi: keng monitorda kartalar cho'zilib ketmasin */}
        <div style={{ maxWidth: 960, margin: '0 auto', width: '100%' }}>
          <Outlet />
        </div>
      </Layout.Content>
      {isMobile && <MobileTabBar />}
    </Layout>
  )
}
